import React from 'react';
import axios from "axios";
import { withRouter, Link } from 'react-router-dom'
import { Card, Tooltip, message } from 'antd';
import { EditOutlined, MailOutlined, EllipsisOutlined } from '@ant-design/icons';
import { withTranslation } from 'react-i18next';
import CardDescription from './CardDescription';

const { Meta } = Card;

class ClientCard extends React.Component {
    state = {

    };

    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
    }

    handleRequestService(service_name, id) {
        if (id) {
            const postObj = {
                id: id,
                service_name: service_name,
                status: 'requested'
            };
            axios.patch(process.env.REACT_APP_AXIOS_URL + "/api/service/user/" + id + "/request/", postObj)
                .then(res => {
                    if (res.status === 200) {
                        this.props.fetch();
                        message.success(this.props.t('clients.client_card.request_sent', "Request sent"));
                    }
                })
        } else {
            const postObj = {
                service_name: service_name,
                status: 'requested'
            };
            axios.post(process.env.REACT_APP_AXIOS_URL + "/api/service/user/create/", postObj)
                .then(res => {
                    if (res.status === 201) {
                        this.props.fetch();
                        message.success(this.props.t('clients.client_card.request_sent', "Request sent"));
                    }
                })
        }
    }

    render() {
        let { service_name } = this.props;
        const { t } = this.props;
        let service_detail_list = this.props.data.service_detail_list;
        let filtered_service_detail, service_id;
        if (service_detail_list)
            filtered_service_detail = service_detail_list.filter(item => item.service_name === service_name);
        if (filtered_service_detail.length)
            filtered_service_detail = filtered_service_detail[0];
        service_id = filtered_service_detail.id


        const actions = [];
        if (filtered_service_detail) {
            if (!filtered_service_detail.status) {
                actions.push(<Tooltip title={t('clients.client_card.request', "Request this service")}>
                    <MailOutlined key="request" onClick={() => this.handleRequestService(service_name, service_id)} />
                </Tooltip >);
            }
            if (filtered_service_detail.status === 'working' || filtered_service_detail.status === 'closed' || filtered_service_detail.status === 'expired') {
                actions.push(<Tooltip title={t('clients.client_card.view', "View more information")}>
                    <Link to={{
                        pathname: '/services/',
                        state: {
                            data: filtered_service_detail
                        }
                    }}><EllipsisOutlined key="edit" /></Link>
                </Tooltip >);

            }
        }

        return (
            <Card
                style={{ width: 350 }}
                hoverable={true}
                actions={actions}
            >
                <Meta
                    title={this.props.title}
                    description={<CardDescription cardDescription={this.props.cardDescription} service_detail={filtered_service_detail} />}
                />
            </Card>
        );
    }
};

export default withRouter(withTranslation()(ClientCard));


// WEBPACK FOOTER //
// ./src/containers/ClientZone/ClientCard.js